module.exports = __webpack_public_path__ + "static/media/sectionAvatarPlaceholder.cec4ccb3.png";